<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/147xDDS/tc-custom/9781952303050.jpg?1694014309606" alt="This image is the cover for the book UNTITLED"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">UNTITLED
      </h1>
      <p class="bookDescription body article font2">
        <p>n/a</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        N/A
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Mad Cave Studios
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c6cfb4a0